<script lang="ts">
	import { onNavigate } from '$app/navigation';

	let loading = $state(false);

	onNavigate((navigation) => {
		// start view transition
		if (!document.startViewTransition) return;

		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
				loading = false;
			});
		});
	});
</script>

{#if loading}
	<div class="relative z-10">
		<div class="fixed inset-0 bg-one opacity-75 transition-opacity delay-150">{''}</div>
		<div class="fixed inset-0 z-10 overflow-y-auto">
			<div
				class="relative flex min-h-screen w-full items-center justify-center overflow-hidden lg:py-5"
			>
				<div class="flex items-center justify-center">
					<div class="relative py-10">
						<span class="loader"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}

<style>
	.loader {
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: inline-block;
		position: relative;
		border: 3px solid;
		border-color: #fff #fff transparent transparent;
		box-sizing: border-box;
		animation: rotation 1s linear infinite;
	}
	.loader::after,
	.loader::before {
		content: '';
		box-sizing: border-box;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		border: 3px solid;
		border-color: transparent transparent #ff3d00 #ff3d00;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		box-sizing: border-box;
		animation: rotationBack 0.5s linear infinite;
		transform-origin: center center;
	}
	.loader::before {
		width: 32px;
		height: 32px;
		border-color: #fff #fff transparent transparent;
		animation: rotation 1.5s linear infinite;
	}

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
	@keyframes rotationBack {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(-360deg);
		}
	}
</style>
